module.exports = __webpack_public_path__ + "static/img_2142-68458a7754c191ab8b90111e3c27acb5.webp";